// Message catalog loader. All catalogs live in frontend/lang/<locale>.json as
// flat dot-notation keys (react-intl consumes flat maps directly). en.json is
// the only hand-authored source of truth; every other locale is agent-generated
// and human-reviewed. qps.json is generated by scripts/generate-pseudo-locale.js.

import { SOURCE_LOCALE } from './config'

type Catalog = Record<string, string>

// Eagerly import every catalog file. Vite resolves this at build time and the
// vitest vite plugin resolves it in tests, so the set of locales is whatever
// files exist under frontend/lang/.
const modules = import.meta.glob<{ default: Catalog }>('../../lang/*.json', {
  eager: true,
})

const catalogs: Record<string, Catalog> = {}
for (const path in modules) {
  const match = path.match(/\/([^/]+)\.json$/)
  if (!match) continue
  const name = match[1]
  // Skip non-catalog sidecar files (e.g. _status.json — the review lifecycle map).
  if (name.startsWith('_')) continue
  catalogs[name] = modules[path].default
}

export const MESSAGES: Record<string, Catalog> = catalogs

export function catalogFor(locale: string): Catalog {
  return catalogs[locale] ?? catalogs[SOURCE_LOCALE] ?? {}
}

export function availableCatalogLocales(): string[] {
  return Object.keys(catalogs)
}

// English catalog — used as the completeness reference and never as a silent
// runtime fallback for user-facing copy (missing keys must surface, not hide).
export const SOURCE_CATALOG: Catalog = catalogs[SOURCE_LOCALE] ?? {}
